import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from "../../../../environments/environment";
import { Observable } from "rxjs/Observable";

@Injectable({
  providedIn: 'root'
})
export class CostCentersService {
  private SERVER_URL = `${environment.API_URL}`;
  constructor(private httpClient: HttpClient) { }

  public getCostCenters(): Observable<any> {
    const params = new HttpParams();
  
    return  this.httpClient.get(this.SERVER_URL + 'cost-centers/costCenters/getCostCenters', { params });
  }

  public createCostCenter(costCenter: any): Observable<any> {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'cost-centers/costCenters/createCostCenter',
      {costCenter},
      { headers });
  }

  public updateCostCenter(costCenter: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'cost-centers/costCenters/updateCostCenter',
      {costCenter},
      { headers });
  }

  public deleteArticle(articleId: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'company-profile/companyProfile/deleteArticle',
      {articleId},
      { headers });
  }

  public deleteCostCenter(costCenterId: any): Observable<any> {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'cost-centers/costCenters/deleteCostCenter',
        {costCenterId},
        { headers });
}
}
